import React, { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { authApi, useAuth } from "../authApi";

export default function AuthCallback() {
  const nav = useNavigate();
  const { setUser } = useAuth();
  const processed = useRef(false);

  useEffect(() => {
    if (processed.current) return;
    processed.current = true;
    const hash = window.location.hash || "";
    const match = hash.match(/session_id=([^&]+)/);
    const sessionId = match ? decodeURIComponent(match[1]) : null;
    (async () => {
      if (!sessionId) { nav("/admin/login", { replace: true }); return; }
      try {
        const u = await authApi.googleSession(sessionId);
        setUser(u);
        const stored = (() => { try { const v = sessionStorage.getItem("om_post_login"); sessionStorage.removeItem("om_post_login"); return v; } catch (_) { return null; } })();
        const dest = stored || "/mon-compte";
        window.history.replaceState(null, "", dest);
        nav(dest, { replace: true });
      } catch (_) {
        nav("/connexion", { replace: true });
      }
    })();
  }, [nav, setUser]);

  return (
    <div className="min-h-screen bg-[#050505] text-white flex items-center justify-center" data-testid="auth-callback">
      <div className="text-sm text-[#C19A6B] uppercase tracking-[0.25em] animate-pulse">Connexion en cours…</div>
    </div>
  );
}
